import { useContext } from 'react'
import { AlertModalContext } from 'data/context/alert-modal-context'

export function UseAlertModal() { return useContext(AlertModalContext) }